<div style="width:100%; background-color: black;" class="layout horizontal center middle">
    <app-tile-set 
        [settings] = settings
        [tiles] = tiles>
    </app-tile-set>
</div>